// CUSTOM: personalised-cart-variant-lookup.js
// Minimal implementation of variant lookup for cart pages

(function() {
  'use strict';
  
  window.personalised = window.personalised || {};
  window.personalised.config = window.personalised.config || {};
  window.personalised.utils = window.personalised.utils || {};
  
  // Ensure minimum utils function is available
  if (!window.personalised.utils.normalizeShopifyId) {
    window.personalised.utils.normalizeShopifyId = function(id) {
      return Number(String(id).replace(/\D/g, ''));
    };
  }
  
  // Create a minimal cart variant lookup implementation
  window.personalised.cartUtils = window.personalised.cartUtils || {};
  
  // First try to get price data from sessionStorage
  window.personalised.cartUtils.getVariantPrices = function(variantId) {
    if (!variantId) return null;
    
    // Normalize the variant ID
    const normalizedId = window.personalised.utils.normalizeShopifyId(variantId);
    
    // First check if we have this stored in sessionStorage
    try {
      const storedData = sessionStorage.getItem('personalised_variant_prices');
      if (storedData) {
        const parsedData = JSON.parse(storedData);
        
        // Try exact match first
        if (parsedData[variantId]) {
          return parsedData[variantId];
        }
        
        // Then try normalized ID
        if (parsedData[normalizedId]) {
          return parsedData[normalizedId];
        }
        
        // Try as string
        if (parsedData[String(variantId)]) {
          return parsedData[String(variantId)];
        }
        
        // Try as string of normalized ID
        if (parsedData[String(normalizedId)]) {
          return parsedData[String(normalizedId)];
        }
        
        // Last try - loop through all keys
        for (const key in parsedData) {
          if (String(key) === String(variantId) || String(key) === String(normalizedId)) {
            return parsedData[key];
          }
        }
      }
    } catch (e) {
      console.warn('Error accessing sessionStorage for variant prices:', e);
    }
    
    // If not in sessionStorage, use product data lookup as fallback
    return window.personalised.cartUtils.lookupVariantPrices(normalizedId);
  };
  
  // Implementation of variant lookup similar to personalised-bundle-ui.js buildVariantLookup
  window.personalised.cartUtils.lookupVariantPrices = function(variantId) {
    if (!variantId || !window.personalised.productData) {
      return null;
    }
    
    // Look through all products and variants to find a match
    for (const productId in window.personalised.productData) {
      const product = window.personalised.productData[productId];
      if (product && product.variants) {
        for (const variant of product.variants) {
          const normalizedId = window.personalised.utils.normalizeShopifyId(variant.id);
          if (normalizedId === variantId) {
            // Save this to sessionStorage for future use
            window.personalised.cartUtils.saveVariantPrice(variantId, {
              price: variant.price,
              compare_at_price: variant.compare_at_price || variant.price
            });
            
            // Return the price data
            return {
              price: variant.price,
              compare_at_price: variant.compare_at_price || variant.price
            };
          }
        }
      }
    }
    
    return null;
  };
  
  // Save a variant price to sessionStorage
  window.personalised.cartUtils.saveVariantPrice = function(variantId, priceData) {
    if (!variantId || !priceData) return;
    
    try {
      // Get existing data or create new object
      let storedData = {};
      const existingData = sessionStorage.getItem('personalised_variant_prices');
      if (existingData) {
        storedData = JSON.parse(existingData);
      }
      
      // Add/update this variant's price data
      storedData[variantId] = priceData;
      
      // Save back to sessionStorage
      sessionStorage.setItem('personalised_variant_prices', JSON.stringify(storedData));
    } catch (e) {
      console.warn('Error saving to sessionStorage:', e);
    }
  };
})();
